import { render, staticRenderFns } from "./inputSelect.vue?vue&type=template&id=708a5fac&scoped=true"
import script from "./inputSelect.vue?vue&type=script&lang=js"
export * from "./inputSelect.vue?vue&type=script&lang=js"
import style0 from "./inputSelect.vue?vue&type=style&index=0&id=708a5fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a5fac",
  null
  
)

export default component.exports